import React from 'react'
import {Box, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import MenuVerticalCard from '../MenuVerticalCard'
import MenuSimpleCard from '../MenuSimpleCard'
import MenuGroupedCategories from '../MenuGroupedCategories'
import {getTemplateLinks, IconLinkButton, hasValidPrimaryCard, templatePropTypes} from './shared'

export const getTemplateFourData = (primarycategory) => {
    const baseCards =
        Array.isArray(primarycategory?.images) && primarycategory.images.length > 0
            ? primarycategory.images
            : [primarycategory?.image_1, primarycategory?.image_2].filter(Boolean)

    return {
        categoryGroup: primarycategory?.category_group ?? [],
        links: getTemplateLinks(primarycategory),
        verticalCards: [...baseCards, primarycategory?.image_3].filter(Boolean).slice(0, 3),
        primaryCard: hasValidPrimaryCard(primarycategory) ? primarycategory.card : null,
    }
}

const TemplateFour = ({primarycategory, categoryData, locale}) => {
    const styles = useMultiStyleConfig('MenuTemplate', {variant: 'template-four'})
    const {categoryGroup, links, verticalCards, primaryCard} = getTemplateFourData(primarycategory)

    return (
        <Box {...styles.templateContainer} data-primarycategory-id={primarycategory?.uid}>
            <Flex {...styles.layout}>
                {!primaryCard && (
                    <Flex {...styles.sideColumn}>
                        {categoryData && categoryGroup.length > 0 && (
                            <Box {...styles.groupOuterContainer}>
                                <Flex {...styles.groupInnerContainer}>
                                    <MenuGroupedCategories
                                        groupedCategories={categoryGroup}
                                        locale={locale}
                                        categoryData={categoryData}
                                        styles={styles}
                                    />
                                </Flex>
                            </Box>
                        )}

                        {links.length > 0 && (
                            <Flex {...styles.linkContainer}>
                                {links.map((link, idx) => (
                                    <IconLinkButton
                                        key={`menu-icon-link-button-${idx}`}
                                        link={link}
                                        categoryData={categoryData}
                                        locale={locale}
                                        styles={styles}
                                    />
                                ))}
                            </Flex>
                        )}
                    </Flex>
                )}

                <Flex {...styles.cardsRow}>
                    {verticalCards.map((card, idx) => (
                        <Box
                            key={card?._metadata?.uid ?? `menu-vertical-card-${idx}`}
                            {...styles.verticalCardWrapper}
                        >
                            {card && (
                                <MenuVerticalCard
                                    card={card}
                                    categoriesData={categoryData}
                                    locale={locale}
                                />
                            )}
                        </Box>
                    ))}

                    {primaryCard && (
                        <Box {...styles.simpleCardWrapper}>
                            <MenuSimpleCard
                                card={primaryCard}
                                categoriesData={categoryData}
                                locale={locale}
                                isLarge
                            />
                        </Box>
                    )}
                </Flex>
            </Flex>
        </Box>
    )
}

TemplateFour.propTypes = templatePropTypes

export default TemplateFour
